import React, { useState, useEffect } from "react";
import "./imageShower.css";

const imageList = [
  {
    id: 1,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/1.png",
    alt: "Image 1",
  },
  {
    id: 2,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/2.png",
    alt: "Image 2",
  },
  {
    id: 3,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/3.png",
    alt: "Image 3",
  },
  {
    id: 4,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/4.png",
    alt: "Image 4",
  },
  {
    id: 5,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/5.png",
    alt: "Image 5",
  },
  {
    id: 6,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/6.png",
    alt: "Image 6",
  },
  {
    id: 7,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/7.png",
    alt: "Image 7",
  },
  {
    id: 8,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/8.png",
    alt: "Image 8",
  },
  {
    id: 9,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/9.png",
    alt: "Image 9",
  },

  {
    id: 11,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/11.png",
    alt: "Image 11",
  },
  {
    id: 12,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/12.png",
    alt: "Image 12",
  },
  {
    id: 13,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/13.png",
    alt: "Image 13",
  },
  {
    id: 14,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/14.png",
    alt: "Image 14",
  },
  {
    id: 15,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/15.png",
    alt: "Image 15",
  },
 
  {
    id: 17,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/17.png",
    alt: "Image 17",
  },
  {
    id: 18,
    src: "../../Images/CommercialImages/9-MariottResidanceInnAtasehir/18.png",
    alt: "Image 18",
  },
];

const MariottShow = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleClosePopup = () => {
    setSelectedImage(null);
  };

  const handleArrowKeyPress = (event) => {
    if (!selectedImage) return;

    const currentIndex = imageList.findIndex(
      (image) => image.id === selectedImage.id
    );

    if (event.key === "ArrowRight") {
      // Go to the next image
      const nextIndex = (currentIndex + 1) % imageList.length;
      setSelectedImage(imageList[nextIndex]);
    } else if (event.key === "ArrowLeft") {
      // Go to the previous image
      const prevIndex =
        (currentIndex - 1 + imageList.length) % imageList.length;
      setSelectedImage(imageList[prevIndex]);
    }
  };

  const handleNextImage = () => {
    if (!selectedImage) return;

    const currentIndex = imageList.findIndex(
      (image) => image.id === selectedImage.id
    );
    const nextIndex = (currentIndex + 1) % imageList.length;
    setSelectedImage(imageList[nextIndex]);
  };

  const handlePrevImage = () => {
    if (!selectedImage) return;

    const currentIndex = imageList.findIndex(
      (image) => image.id === selectedImage.id
    );
    const prevIndex = (currentIndex - 1 + imageList.length) % imageList.length;
    setSelectedImage(imageList[prevIndex]);
  };

  useEffect(() => {
    // Add event listener for arrow key press
    const handleKeyDown = (event) => handleArrowKeyPress(event);

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedImage]);

  return (
    <div className="image-grid-container">
      <div className="image-grid">
        {imageList.map((image) => (
          <div
            key={image.id}
            className="image-wrapper"
            onClick={() => handleImageClick(image)}
          >
            <img src={image.src} alt={image.alt} className="image" />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="popup1" onClick={handleClosePopup}>
          <div className="popup-content">
            {/* Next and Previous buttons outside the image div */}
            <button
              className="arrow-button2 left-arrow2"
              style={{
                backgroundColor: "#121212",
                height: "50px",
                width: "50px",
                color: "#fff",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handlePrevImage();
              }}
            >
              &#8592; {/* Left arrow symbol */}
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            />
            <p>{selectedImage.alt}</p>
            <button
              className="arrow-button2 right-arrow2"
              style={{
                backgroundColor: "#121212",
                height: "50px",
                width: "50px",
                color: "#fff",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleNextImage();
              }}
            >
              &#8594; {/* Right arrow symbol */}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
export default MariottShow;
